'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BackgroundImage = function () {
  function BackgroundImage() {
    'ngInject';

    _classCallCheck(this, BackgroundImage);

    this.restrict = 'A';
  }

  _createClass(BackgroundImage, [{
    key: 'link',
    value: function link($scope, element, attrs) {
      var url = attrs.backgroundImage;
      element.css({
        background: 'url(\'' + url + '\') no-repeat center center fixed',
        'background-size': 'cover'
      });
    }
  }], [{
    key: 'directiveFactory',
    value: function directiveFactory() {
      'ngInject';

      return new BackgroundImage();
    }
  }]);

  return BackgroundImage;
}();

exports.default = BackgroundImage;


// WEBPACK FOOTER //
// ./common/directives/background-image.js